import * as amplitude from '@amplitude/analytics-browser';

export const Events = {
  CONNECT_WALLET: 'Connect Wallet',
  CONFIRM_WALLET: 'Confirm Wallet',
  CREATE_ROOM: 'Create Room',
  JOIN_ROOM: 'Join Room',
  SUCCESS_GAME: 'Success Game',
  TAKE_BET_BACK: 'Take Bet Back',
  TECHNICAL_DEFEAT_CLOSURE: 'Technical Defeat Closure',
  LOW_BET: 'Low Bet',
  QUCK_GAME_START: 'Quick Game Start',
} as const;

export const TwqEvents = {
  CONNECT_WALLET: 'tw-op1jf-op1jl',
  GAME_STARTED: 'tw-op1jf-op1jr',
  GAME_FINISHED: 'tw-op1jf-op1k2',
} as const;

export interface EventParams {
  [key: string]: any;
}

export function track(name: string, params: EventParams = {}): void {
  amplitude.track(name, params);
}

export function customTrackFb(name: string, params: EventParams = {}): void {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('customTrack', name);
  } else {
    console.warn('[meta pixel]: tracking function is not available.', name);
  }
}

export function customTrackTwitter(name: string, params: EventParams = {}): void {
  if (typeof window !== 'undefined' && (window as any).twq) {
    (window as any).twq('event', name, params);
  } else {
    console.warn('[tw pixel]: tracking function is not available.', name);
  }
}

export function checkUserId(wallet: string) {
  const uid = amplitude.getUserId();
  if (uid !== wallet) {
    amplitude.setUserId(wallet);
  }
}
export function getSearchParams(): Record<string, string> | undefined {
  try {
    const urlSearchParams = sessionStorage.getItem('urlSearchParams');
    if (!urlSearchParams) return undefined;
    const params = JSON.parse(urlSearchParams) as Record<string, string>;
    return params && typeof params === 'object' ? params : undefined;
  } catch {
    return undefined;
  }
}

export const Analytics = {
  // Amplitude events
  connectWalletEvent(wallet: string, ref: string | null, balance: number, currency: string) {
    const utmParams = getSearchParams();
    track(Events.CONNECT_WALLET, { wallet, ref, balance, currency, utm_params: utmParams });
  },

  confirmWalletEvent(wallet: string) {
    const utmParams = getSearchParams();
    track(Events.CONFIRM_WALLET, { wallet, utm_params: utmParams });
  },

  createRoomEvent(wallet: string, ref: string | null, bet: number, currency: string) {
    const utmParams = getSearchParams();
    track(Events.CREATE_ROOM, { wallet, ref, bet, currency, utm_params: utmParams });
  },

  joinRoomEvent(wallet: string, ref: string | null, bet: number, currency: string) {
    const utmParams = getSearchParams();
    track(Events.JOIN_ROOM, { wallet, ref, bet, currency, utm_params: utmParams });
  },

  successGameEvent(wallet: string, ref: string | null) {
    track(Events.SUCCESS_GAME, { wallet, ref });
  },

  takeBetBackEvent(wallet: string, roomId: number) {
    track(Events.TAKE_BET_BACK, { wallet, roomId });
  },

  techDefeatEvent(wallet: string, roomId: number) {
    track(Events.TECHNICAL_DEFEAT_CLOSURE, { wallet, roomId });
  },

  lowBetEvent(wallet: string, balance: number) {
    track(Events.LOW_BET, { wallet, balance });
  },

  homePageItemClickEvent(eventName: string) {
    track(eventName, {});
  },

  quickGameStartEvent(wallet: string, bet: number, currency: string) {
    track(Events.QUCK_GAME_START, { wallet, bet, currency });
  },

  // Helpers
  handleUserId(wallet: string) {
    checkUserId(wallet);
  },
};
